import React from 'react';
import { RegisterConfigPage } from './RegisterConfigPage';

export const RemediationConfigPage: React.FC = () => {
  return <RegisterConfigPage kind="remediation" />;
};
